module.exports = __webpack_public_path__ + "static/media/13d.2a255fc7.png";